"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Search = function Search(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.484 3.992C3.921 8.565 3.47 15.782 7.111 20.866L.706 27.272c-.047.046-.082.1-.122.15a2.01 2.01 0 0 0 .068 2.646c.02.021.033.044.054.064l.008.008c.755.745 1.943.77 2.734.089.039-.035.082-.061.118-.097l6.431-6.431c5.055 3.664 12.234 3.278 16.798-1.295 5.069-5.083 5.083-13.344.035-18.418-5.048-5.078-13.276-5.077-18.345.004zm15.952 16.041c-3.763 3.772-9.87 3.774-13.619.003-3.749-3.77-3.741-9.903.024-13.673 3.762-3.772 9.871-3.774 13.621-.003 3.749 3.771 3.736 9.903-.027 13.673z"
  }));
};

var _default = Search;
exports["default"] = _default;